import React from 'react';

const PaginatedTableContainer = ({
    columns,
    data,
    loading,
    currentPage,
    totalPages,
    onPageChange,
    onRowClick
}) => {
    // 페이지 범위 계산 (10개씩 묶어서 표시)
    const getPageRange = () => {
        const maxVisible = 10;
        
        // 현재 페이지가 속한 10개 구간 찾기 (0-based)
        const currentGroup = Math.floor(currentPage / maxVisible);
        const start = currentGroup * maxVisible;
        const end = Math.min(start + maxVisible - 1, totalPages - 1);
        
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    const pageRange = getPageRange();

    const handleRowClick = (item) => {
        if (onRowClick) {
            onRowClick(item);
        }
    };

    return (
        <>
            {/* 테이블 */}
            <div className="bg-white border border-gray-400 overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                    <thead>
                        <tr className="bg-gray-200">
                            {columns.map((column, index) => (
                                <th key={index} className={`border border-gray-400 px-1 py-1 text-left whitespace-nowrap ${column.minWidth || ''}`}>
                                    {column.header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={columns.length} className="border border-gray-400 py-2 text-center">
                                    서버에서 데이터를 가져오는 중입니다 ...
                                </td>
                            </tr>
                        ) : data.length === 0 ? (
                            <tr>
                                <td colSpan={columns.length} className="border border-gray-400 py-2 text-center">
                                    데이터가 없습니다.
                                </td>
                            </tr>
                        ) : (
                            data.map((item, index) => (
                                <tr 
                                    key={index} 
                                    className={`hover:bg-gray-50 ${onRowClick ? 'cursor-pointer' : ''}`}
                                    onClick={() => handleRowClick(item)}
                                >
                                    {columns.map((column, colIndex) => (
                                        <td key={colIndex} className="border border-gray-400 px-1 py-1 whitespace-nowrap">
                                            {column.render ? column.render(item) : item[column.field]}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* 페이지네이션 */}
            <div className="mt-3 flex items-center justify-center gap-1">
                {/* 첫 페이지 */}
                <button 
                    onClick={() => onPageChange(0)}
                    disabled={currentPage === 0}
                    className="px-2 py-1 border border-gray-400 bg-gray-200 hover:bg-gray-300 disabled:bg-gray-100 disabled:text-gray-400 text-xs"
                >
                    &lt;&lt;
                </button>
                
                {/* 이전 페이지 */}
                <button 
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 0}
                    className="px-2 py-1 border border-gray-400 bg-gray-200 hover:bg-gray-300 disabled:bg-gray-100 disabled:text-gray-400 text-xs"
                >
                    &lt;
                </button>
                
                {/* 페이지 번호들 */}
                {pageRange.map((page) => (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`px-2 py-1 border border-gray-400 text-xs ${
                            page === currentPage 
                                ? 'bg-blue-200 font-bold' 
                                : 'bg-gray-200 hover:bg-gray-300'
                        }`}
                    >
                        {page + 1}
                    </button>
                ))}
                
                {/* 다음 페이지 */}
                <button 
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage >= totalPages - 1}
                    className="px-2 py-1 border border-gray-400 bg-gray-200 hover:bg-gray-300 disabled:bg-gray-100 disabled:text-gray-400 text-xs"
                >
                    &gt;
                </button>
                
                {/* 마지막 페이지 */}
                <button 
                    onClick={() => onPageChange(totalPages - 1)}
                    disabled={currentPage >= totalPages - 1}
                    className="px-2 py-1 border border-gray-400 bg-gray-200 hover:bg-gray-300 disabled:bg-gray-100 disabled:text-gray-400 text-xs"
                >
                    &gt;&gt;
                </button>
            </div>
        </>
    );
};

export default PaginatedTableContainer; 